<script setup lang="ts">
import { useFile } from '@corp/composables/file'
import type { UploadedPhoto } from '@consumer/types/Photo'
import { openAlertModal } from '@consumer/services/modals'
import spinnerIcon from '@consumer/assets/icons/spinner.svg?svgicon'
import newImageIcon from '@consumer/assets/icons/new/image.svg?svgicon'

const emit = defineEmits<{ setImage: [image: UploadedPhoto] }>()

const { upload, isUploading } = useFile()

const fileInput = ref<HTMLInputElement>()

async function onSelectFile (e: Event) {
  const { files } = e.target as HTMLInputElement
  if (files && files[0]) {
    if (files[0].type === 'image/webp') {
      openAlertModal({
        name: 'webp-image',
        danger: true,
        header: 'Invalid image format',
        content: h('div', { class: 'space-y-6' },
          'Sorry we do not support this image format, please upload a .png or .jpg image.'),
      })
      return
    }
    const blob = await upload(files[0])
    const photo = {
      id: blob.signed_id,
      filename: blob.filename,
      imageUrl: blob.url,
      thumbnailUrl: blob.url,
      provider: 'user',
    } as UploadedPhoto
    emit('setImage', photo)
  }
}
</script>
<template>
  <div
    class="border-dashed border-2 border-primary-base rounded-lg
           flex items-center justify-center text-primary-base font-semibold clickable"
    style="aspect-ratio: 3/2;"
    data-testid="image-upload"
    @click="fileInput?.click()"
  >
    <div v-if="isUploading">
      <GIcon :svg="spinnerIcon" size="24px" class="block animate-spin icon-spinner"/>
    </div>
    <div v-else>
      <GIcon :svg="newImageIcon" class="block mt-0 mb-3 mx-auto" size="24px"/>
      Add your image
    </div>
    <input ref="fileInput" type="file" accept="image/*" style="display: none;" @change="onSelectFile">
  </div>
</template>
